<template>
    <!--新增界面-->
    <div v-if="formVisible">
        <el-dialog v-dragDialog :title="formTitle" :visible.sync="formVisible" width="600px"
            :close-on-click-modal="false">
            <el-form :model="addForm" ref="dataForm" label-width="110px" :rules="formRules">
                <el-form-item label="奖品名称:" prop="Name">
                    <el-input v-model="addForm.Name" auto-complete="off" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="奖品价值:" prop="Price">
                    <el-input-number v-model="addForm.Price" size="small"></el-input-number>
                </el-form-item>
                <el-form-item label="发行数量:" prop="Count">
                    <el-input-number v-model="addForm.Count" size="small"></el-input-number>
                </el-form-item>
                <el-form-item label="有效起期:" prop="BeginDate">
                    <el-date-picker v-model="addForm.BeginDate" type="date" size="small" placeholder="请选择开始日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="有效止期:" prop="EndDate">
                    <el-date-picker v-model="addForm.EndDate" type="date" size="small" placeholder="请选择截止日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="奖品图片:" prop="Logo">
                    <img v-if="addForm.Logo" :src="baseUrl + addForm.Logo" :key="addForm.Logo" style="height: 60px" />
                    <el-button class="submit-btn" type="warning" size="mini" @click="selectFile">点此上传</el-button>
                </el-form-item>
                <el-form-item label="兑奖说明:" prop="Description">
                    <el-input type="textarea" :rows="6" v-model="addForm.Description" auto-complete="off"
                        placeholder="请输入兑奖说明"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="formVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit">提交</el-button>
            </div>
        </el-dialog>
        <fileUploadNoUI ref="fileUploadNoUI" @uploadSuccess="uploadSuccess" />
    </div>
</template>
<script>
import { save } from "@/api/activity/award";
import fileUploadNoUI from "@/components/fileUploadNoUI";
export default {
    components: {
        fileUploadNoUI,
    },
    data() {
        return {
            formVisible: false,
            fromTitle: "添加奖品",
            addForm: {},
            formRules: {
                Name: [{ required: true, message: "请输入名称", trigger: "change" }],
                Count: [{ required: true, message: "请输入名称", trigger: "change" }],
                Price: [{ required: true, message: "请输入价值", trigger: "change" }],
                BeginDate: [{ required: true, message: "请输入有效起期", trigger: "change" }],
                EndDate: [{ required: true, message: "请输入有效止期", trigger: "change" }],
                Description: [{ required: true, message: "请输入兑奖说明", trigger: "change" }],
            },
        };
    },
    methods: {
        uploadSuccess(val) {
            this.addForm.Logo = val.Path;
        },
        selectFile() {
            this.$refs.fileUploadNoUI.chooseFile();
        },
        handleCreate() {
            this.formTitle = "添加奖品";
            this.formVisible = true;
            this.addForm = {
                Name: "",
                BeginDate: "",
                EndDate: "",
                Price: 0,
                Count: 0,
                Description: "",
            };
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleUpdate(row) {
            this.addForm = JSON.parse(JSON.stringify(row));
            this.addForm.BeginDate = this.format.dateFormat(row.BeginDate);
            this.addForm.EndDate = this.format.dateFormat(row.EndDate);
            this.formTitle = "修改奖品";
            this.formVisible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].clearValidate();
            });
        },
        handleSubmit() {
            this.$refs["dataForm"].validate((valid) => {
                if (valid) {
                    let para = Object.assign(this.addForm);
                    this.$confirm("确认提交吗？", "提示", {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                    }).then(() => {
                        save(para).then((response) => {
                            if (response) {
                                this.formVisible = false;
                                this.$emit("update")
                            }
                        });
                    });
                }
            });
        },
    },
    mounted() {
    },
};
</script>